import { ArrowUp } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES, scrollToId } from "../data/site";

export default function Footer() {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-black border-t border-white/10 pt-16 pb-8 overflow-hidden">
      <div className="container-x">
        <div className="flex justify-center mb-2">
          <img src="/logo-full.webp" alt="vic wrap studio logo" className="h-36 sm:h-48 w-auto object-contain" />
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-[#FF2A2A] to-transparent my-12" />

        <div className="grid sm:grid-cols-3 gap-10 mb-14">
          <div>
            <div className="font-tech text-[10px] uppercase tracking-[0.25em] text-[#FF6B00] mb-5">Navigate</div>
            <div className="flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => scrollToId(l.id)}
                  className="text-left text-sm text-zinc-400 hover:text-[#FF6B00] transition-colors duration-200 w-fit"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div data-testid="footer-seo-links-container">
            <div className="font-tech text-[10px] uppercase tracking-[0.25em] text-[#FF6B00] mb-5">Melbourne Services</div>
            <div className="flex flex-col gap-3">
              {SERVICES.map((s) => (
                <button
                  key={s.id}
                  onClick={() => scrollToId(s.id)}
                  className="text-left text-sm text-zinc-400 hover:text-[#FF6B00] transition-colors duration-200 w-fit"
                >
                  {s.seo}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="font-tech text-[10px] uppercase tracking-[0.25em] text-[#FF6B00] mb-5">Get in touch</div>
            <div className="flex flex-col gap-3 text-sm text-zinc-400">
              <a href={BRAND.phoneHref} className="hover:text-[#FF6B00] transition-colors w-fit">{BRAND.phone}</a>
              <a href={BRAND.emailHref} className="hover:text-[#FF6B00] transition-colors w-fit break-all">{BRAND.email}</a>
              <span>{BRAND.location}</span>
              <span className="text-zinc-500">Servicing Melbourne & surrounding areas</span>
              <button onClick={() => scrollToId("quote")} className="btn-primary mt-3 w-fit !px-5 !py-3 text-xs">
                GET A FREE QUOTE
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-7">
          <p data-testid="footer-copyright-text" className="text-xs text-zinc-600">
            © 2026 VIC WRAP STUDIO — Melbourne, Victoria. Concept. Design. Install.
          </p>
          <button
            data-testid="footer-back-to-top-button"
            onClick={toTop}
            className="flex items-center gap-2 text-xs font-tech uppercase tracking-[0.2em] text-zinc-500 hover:text-[#FF6B00] transition-colors duration-200"
          >
            Back to top <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
